import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeLike, meshGeometryAttributeLikeMarker} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {MeshGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {WeldOperatorParameters} from "#template/nodes/geometry-graph/attribute/weld-operator/geometry-weld-operator-node"
import {GeometryWeldOperatorNode, weldOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute/weld-operator/geometry-weld-operator-node"

export type MeshGeometryWeldOperatorParameters = WeldOperatorParameters<MeshGeometryAttributeLikeNode>

const definition: TemplateNodeDefinition<MeshGeometryWeldOperatorParameters> = {
    nodeClass: "MeshGeometryWeldOperator",
    validation: {
        parameters: weldOperatorParametersSchema(meshGeometryAttributeLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryWeldOperator extends GeometryWeldOperatorNode<2, MeshGeometryAttributeLikeNode> implements MeshGeometryAttributeLikeNode {
    get [meshGeometryAttributeLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
